import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { map, mergeMap, take } from 'rxjs';
import { BANNER_TYPE } from 'src/app/components/banner/banner.constants';
import { BUTTON_TYPES } from 'src/app/components/shared/modal/components/modal-frame/modal-frame.constants';
import { IMAGE_SRC } from 'src/app/components/shared/shared-constants';

import { OtherReportsService } from 'src/app/core/services/reports/other/other-reports.service';
import { UserService } from 'src/app/core/services/user/user.service';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { ReportsUtils } from 'src/app/core/utils/reports/reports.utils';
import {
  CONSTS,
  NonUpsBarcodeFormGroup,
  REPORT_FILE_NAME,
} from './non-ups-barcode-extract.constants';

@Component({
  selector: 'app-non-ups-barcode-extract',
  templateUrl: './non-ups-barcode-extract.component.html',
  styleUrls: ['./non-ups-barcode-extract.component.scss'],
  standalone: false,
})
export class NonUpsBarcodeExtractComponent implements OnInit {
  readonly destroy = inject(DestroyRef);
  readonly input: NonUpsBarcodeFormGroup = inject(MAT_DIALOG_DATA);
  private userService = inject(UserService);
  private fb: FormBuilder = inject(FormBuilder);
  private dialogRef: MatDialogRef<NonUpsBarcodeExtractComponent> = inject(
    MatDialogRef<NonUpsBarcodeExtractComponent>,
  );
  private otherReportsService: OtherReportsService =
    inject(OtherReportsService);
  private commonUtils: CommonUtils = inject(CommonUtils);
  private reportUtils: ReportsUtils = inject(ReportsUtils);
  currDate!: Date;
  minDate!: Date;
  maxDate!: Date;
  nonUpsBarcodeForm!: FormGroup;

  readonly CONSTS = CONSTS;
  readonly IMAGES = IMAGE_SRC;
  readonly BUTTON_TYPES = BUTTON_TYPES;

  ngOnInit(): void {
    this.currDate = new Date();
    this.minDate = new Date(
      this.currDate.getFullYear(),
      this.currDate.getMonth(),
      this.currDate.getDate() - 30,
    );
    this.maxDate = new Date(
      this.currDate.getFullYear(),
      this.currDate.getMonth(),
      this.currDate.getDate() + 14,
    );

    this.nonUpsBarcodeForm = this.fb.group({
      date: [this.currDate],
    });
  }

  onExit() {
    this.commonUtils.openExitModal(this.nonUpsBarcodeForm.dirty);
  }

  /**
   * Used to get report in CSV or PDF file format
   *
   * @memberof LocationSummaryComponent
   */
  getReport() {
    this.userService
      .getCurrentUser$()
      .pipe(
        take(1),
        mergeMap((user) => {
          const formValue = this.nonUpsBarcodeForm.value;

          const locationCode = user?.location;
          const date = this.commonUtils.getFormattedDate(formValue.date);

          const request = {
            locationCode,
            date,
          };
          return this.otherReportsService.getNonBarcodeReport(request).pipe(
            take(1),
            map((data) => {
              const nonUpsBarcode = data.response.nonUpsBarcode;

              if (nonUpsBarcode?.length) {
                const customHeader = [
                  ['', '', 'Non-UPS Barcode Extract', '', ''],
                ];
                this.reportUtils.exportCSVReport(
                  nonUpsBarcode,
                  REPORT_FILE_NAME,
                  customHeader,
                );
              } else {
                this.commonUtils.updateBannerType(
                  BANNER_TYPE.NO_DATA_AVAILABLE,
                );
              }

              this.dialogRef.close();
            }),
          );
        }),
      )
      .subscribe();
  }
}
